export const headerHeight = 64;
export const verticalPaddingsContainer = 40;